﻿import {Delegate} from "../Tools/Delegate.js";
import {FetchAbstract} from "./FetchAbstractHelper.js";
import {HandledError} from "../Tools/HandledError.js";
import {TokenHelper} from "./TokenHelper.js";
import {String} from "../Tools/Misc.js"
import {NotificationHelper} from "./NotificationHelper.js";


export class JsonFetchJson extends FetchAbstract {

    public static override Get = async <T>(url: string, headers: Headers = null): Promise<T> => {

        headers = headers == null ? new Headers() : headers;
        headers.append("Accept", "application/json");

        return super.Get(url, headers);
    }

    public static Post = async <T>(url: string, body: any = null, headers: Headers = null): Promise<T> => {
        headers = headers == null ? new Headers() : headers;
        headers.append("Accept", "application/json");
        headers.append("Content-Type", "application/json");

        return super.Post(url, body, headers);
    }

    public static Delete = async <T>(url: string, body?: any, headers: Headers = null): Promise<T> => {
        headers = headers == null ? new Headers() : headers;
        headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json");

        return super.Delete(url, body, headers);
    }

    public static Put = async <T>(url: string, body: any = null, headers: Headers = null): Promise<T> => {
        headers = headers == null ? new Headers() : headers;
        headers.append("Accept", "application/json");
        headers.append("Content-Type", "application/json");

        return super.Put(url, body, headers);
    }
}

/*
* Envoie une requête HTTP POST avec le contenu text/plain et le retour en JSON
* */
export class TextFetchJson extends FetchAbstract {

    public static Post = async <T>(url: string, body: any = null, headers: Headers = null): Promise<T> => {
        headers = headers == null ? new Headers() : headers;
        headers.append("Accept", "application/json");
        headers.append("Content-Type", "text/plain");

        return super.Post(url, body, headers);
    }
}

/**
 * Envoie une requête HTTP POST avec le contenu text/plain et le retour en text/plain
 * */
export class TextFetchText extends FetchAbstract {
    public static Post = async <T>(url: string, body: any = null, headers: Headers = null): Promise<T> => {
        headers = headers == null ? new Headers() : headers;
        headers.append("Accept", "text/plain");
        headers.append("Content-Type", "text/plain");

        return super.Post(url, body, headers);
    }
}

/**
 * Envoie une requête HTTP POST avec le contenu JSON et le retour en text/plain
 * */
export class JsonFetchText extends FetchAbstract {
    public static Post = async <T>(url: string, body: any = null, headers: Headers = null): Promise<T> => {
        headers = headers == null ? new Headers() : headers;
        headers.append("Accept", "text/plain");
        headers.append("Content-Type", "application/json");

        return super.Post(url, body, headers);
    }
}


export class FetchFile {
    public OnProgress: Delegate;

    constructor() {
        this.OnProgress = new Delegate();
    }

    public Post = async <T>(url: string, file: File): Promise<T> => {

        return this.fetchXhr<T>({url: url, method: "POST", file: file})
            .then((response) => {
                return response;
            })

    }

    public Put = async <T>(url: string, file: File): Promise<T> => {

        return this.fetchXhr<T>({url: url, method: "PUT", file: file})
            .then((response) => {
                return response;
            });
    }

    public Get = async (url): Promise<Blob> => {
        return this.fetchXhr<any>({url: url, method: "GET", responseType: "blob"})
            .then((response) => {
                const contentType = response.type || "application/octet-stream";
                return new Blob([response], {type: contentType});
            });
    }

    private fetchXhr = async <T>(option: IFetchXhrOptions): Promise<T> => {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open(option.method, option.url, true);
            if (option.responseType != null)
                xhr.responseType = option.responseType;

            if (!String.IsNullOrEmpty(TokenHelper.Instance.Token)) {
                xhr.setRequestHeader("Authorization", `bearer ${TokenHelper.Instance.Token}`)
            }

            xhr.onerror = (ev) => {
                reject(new HandledError(`Erreur lors du chargement de l'image. Status : ${xhr.status}`));
            }

            xhr.onload = (r) => {
                if (xhr.status == 200) {
                    {
                        // On tente de parse en JSON
                        try {
                            const jsonData = JSON.parse(xhr.response);
                            if (jsonData["status"] != null && jsonData["errorMessage"] != null && jsonData["status"] != 200)
                                NotificationHelper.Instance.error(jsonData["errorMessage"]);
                            resolve(jsonData);
                        } catch {
                            // Si erreur, on revoie la réponse brute de fonderie.
                            if (option.responseType == "blob") {
                                resolve(xhr.response)
                            }
                        }
                    }
                } else {
                    reject(new HandledError(`Erreur lors du chargement de l'image. Status : ${xhr.status}`))
                }
            }

            xhr.upload.onprogress = (ev) => {
                const perscentComplete = (ev.loaded / option.file.size) * 100;
                this.OnProgress.Fire(perscentComplete);
            }

            if (option.file != null) {
                const formData = new FormData();
                formData.append("file", option.file);
                xhr.send(formData);

                return;
            }

            xhr.send();
        });

    }
}

export interface IFetchXhrOptions {
    url: string,
    method: string,
    file?: File,
    responseType?: XMLHttpRequestResponseType
    mimeType?: string;
}

    
